export default class User {
    constructor(UserID, FullName, Email, Password, Mobile, UserIsDisabled, UserMustChangePassword, AccountIsLockedOut, IsPrimaryOfficer,IsSecondaryOfficer) {
      this.UserID = UserID;
      this.FullName = FullName;
      this.Email = Email;
      this.Mobile = Mobile;
      this.UserIsDisabled = UserIsDisabled;
      this.UserMustChangePassword = UserMustChangePassword;
      this.AccountIsLockedOut = AccountIsLockedOut;
      this.IsPrimaryOfficer = IsPrimaryOfficer;
      this.IsSecondaryOfficer = IsSecondaryOfficer
      this.Password = Password;
    }
  }